import { z } from "zod";

export const FilterSchema = z.record(z.any());

export const ColumnOptionsSchema = z.object({
    header: z.string().optional(),
    pin: z.enum(["left", "right"]).optional(),
});

export const ViewOptionsSchema = z.object({
    bulkActions: z.boolean().optional(),
    selection: z.boolean().optional(),
    readonly: z.boolean().optional(),
});

export const ColumnSchema = z.object({
    id: z.string(),
    options: ColumnOptionsSchema.optional(),
});

export const ViewSchema = z.object({
    type: z.enum(["transaction", "workspace", "client"]),
    columns: z.array(ColumnSchema),
    filters: FilterSchema,
    options: ViewOptionsSchema.optional(),
});

export const PersistedViewSchema = ViewSchema.extend({
    id: z.string(),
    name: z.string(),
});

export type ViewOptions = z.infer<typeof ViewOptionsSchema>;
export type View = z.infer<typeof ViewSchema>;
export type ColumnOptions = z.infer<typeof ColumnOptionsSchema>;
